import { openWithTenant } from '@app-store'
import {
  AddressType,
  addToaster,
  AuthUser,
  ContactPatientProviderType,
  CaseDataType,
  DataTypeStore,
  EntityLookupSearchCriteria,
  fetchEntityIdByNameCorrespondingToSelectedClient,
  fetchLayoutIdApi,
  formatDataObject,
  getBase64forDocumentPreview,
  getDownloadDocURLApi,
  getGenericEntityListingAPI,
  GetGenericEntityListingApiType,
  getLayoutByIdApi,
  hideLoader,
  LookupRelatedEntities,
  showLoader,
  TableFilterLookupObjectBody,
  TableFilterObjectBody,
  WorkflowInstanceTaskType,
  PermissionsDataType,
  fetchTypeStatusForCommunications,
  updateIntake,
  detachIntake,
  UpdateIntakePayload,
  DataType,
  SearchCriteria,
  resendCommunicationAPI,
  getWorkflowByEntityNameAndRecordId,
  updateCaseData,
  AgeBucketDashboardResponse,
  UserStatusSummaryList,
  TooltipContext,
  appendTenantIdToPath,
  getTenantIdFromWindow,
  invalidateMsalUserToken,
} from '@app-store'
import moment from 'moment'
import { Dispatch } from 'react'
import { UnknownAction } from 'redux-saga'
import * as XLSX from 'xlsx'
import { v4 as uuid } from 'uuid'
import { CorrespondenceOptions } from '../pages/correspondence-logs/correspondenceTypes'
import {
  COMM_TEMPLATE,
  correspondenceLogsPage,
  ENTITY_ID,
  ENTITY_NAME,
  EXTENSIONS,
  MATCH_DEDUPE_RESULT_LABEL,
  MATCH_DEDUPE_RESULTS,
  NAMESPACES,
  GLOBAL_PERMISSION_SETS,
  GLOBAL_UAM_PERMISSIONS,
  PERMISSION_MODULES,
  USER_PROFILES,
  WORKFLOW_STATUS,
  RECIPENT_LABEL_OFFICE_FAX,
  DASHBOARD,
  INTAKE_QUEUE,
  INTAKE_STATUS,
} from './constants'
import { ProgramPermissionsDataType } from '../types/permission.types'
import {
  caseTypePermissionMapping,
  currentUserId,
  getReverseMapping,
  isCaseType,
  isProgramAdmin,
  isReadOnlyUser,
  isSuperAdmin,
} from './permission'
import { DYNAMIC_QUEUE_CONSTANTS } from '../constants/dynamicQueue'
import { ViewObjectEntry } from '../types/types'
import { parseISO } from 'date-fns'
import { DynamicQueuesType } from '../types/queueConfig.types'
import {
  FORMAT_PATTERN,
  formatPhoneNumber as formatPhoneNumberUi,
  getHtmlDataType,
  HTML_TYPE,
  MULTI_UPLOAD_FILE_TYPE,
  TableColumnType,
} from '@ui-kit'
import _ from 'lodash'
import {
  BarChartOptionsProps,
  ColumnChartOptionsProps,
  ContentTypeProps,
  FileType,
  RecordType,
} from './types'
import { store, RootState } from './agent.store'
import { FieldValues } from 'react-hook-form'
import { PlotSeriesOptions, SeriesOptionsType } from 'highcharts'
import { getEntityDataByIdEntityNameEmbedded } from '../apis/entityData.api'
import { STRINGS } from './strings'
import { UiDataMappingsType } from '../types/correspondenceLogs.types'
import { QUEUE_STRINGS } from './queueIntake.types'
export const convertToCamelCase = (str: string): string => {
  return str
    .split('_')
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join('')
}

export const capitalizeEntitySingularLabel = (label: string) => {
  if (label.includes('_')) {
    return label
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  } else {
    return label
      ?.split(' ')
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      ?.join(' ')
  }
}
export const toSpacesCase = (str: string) => {
  return str
    ?.replace(/([a-z])([A-Z])/g, '$1 $2')
    ?.replace(/_/g, ' ')
    ?.replace(/\s+/g, ' ')
    ?.trim()
    ?.replace(/\b\w/g, (c) => c?.toUpperCase())
}
export const formatPhoneNumber = (value: string | number) => {
  const valueStr = value.toString()
  const digits = valueStr.replace(/\D/g, '')
  if (digits.length <= 3) {
    return digits
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  } else {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
      6,
      10
    )}`
  }
}

export const formatFaxNumber = (value: string | number) => {
  const valueStr = value?.toString()
  const digits = valueStr?.replace(/\D/g, '')
  if (digits?.length <= 3) {
    return digits
  } else if (digits?.length <= 6) {
    return `(${digits?.slice(0, 3)}) ${digits?.slice(3)}`
  } else {
    return `${digits?.slice(0, 1)}-(${digits?.slice(1, 4)})-${digits?.slice(
      4,
      7
    )}-${digits?.slice(7, digits.length)}`
  }
}

export const extractTextFromHTML = (html: string) => {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.textContent ?? ''
}

export const formatHtmlBeforePreview = (res: string) => {
  const response = res
  const cleanedHtml = response
    .replace(/<</g, '&lt;&lt;')
    .replace(/>>/g, '&gt;&gt;')
    .replace(/Â/g, '')
  return cleanedHtml
}

const cleanHTML = (html: string) => {
  const bodyMatch = /<body[\s\S]*?>([\s\S]*?)<\/body>/i.exec(html)
  return bodyMatch ? bodyMatch[1] : ''
}

export const loadCSSAndBuildHTMLForSendingCommunication = (
  //TODO: change later when cssData is applied from BE
  editorData: string,
  bodyType?: string
) => {
  try {
    const htmlType = getHtmlDataType(editorData)
    if (
      bodyType === HTML_TYPE.DOCX_UPPPERCASE ||
      htmlType === HTML_TYPE.BASE64_PDF
    ) {
      return editorData
    }
    if (
      editorData.startsWith(
        '<!DOCTYPE html><html><head><meta charset="UTF-8"><style>'
      )
    ) {
      return editorData
    }

    const cleanedData = cleanHTML(editorData)

    const completeHtml = `<!DOCTYPE html><html><head><meta charset="UTF-8"><style></style></head><body><div class="ck"><div class="ck-content">${cleanedData}</div></div></body></html>`

    return completeHtml
  } catch (error) {
    console.error('Error loading CSS:', error)
    return null
  }
}

export const makeEditableWithRedBackground = (html: string) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const editableDivs = doc.querySelectorAll('div')

  editableDivs.forEach((div) => {
    if (div.className.startsWith('editable')) {
      const hasEditableSpan = div.querySelector('span[contenteditable="true"]')

      if (!hasEditableSpan) {
        const innerHTML = div.innerHTML
        div.innerHTML = `<span style="background-color: #E2282866;" contenteditable="true">${innerHTML}</span>`
      }
    }
  })

  return doc.body.innerHTML
}

export const fetchEntityIdByName = async (
  dispatch: Dispatch<UnknownAction>,
  entityName: string
) => {
  try {
    const response = await fetchEntityIdByNameCorrespondingToSelectedClient(
      entityName
    )
    if (response) {
      return response?.data
    }
  } catch (err) {
    console.error(err)
    dispatch(
      addToaster({
        message: `Error fetching ${entityName} Entity`,
        type: 'error',
        id: uuid(),
      })
    )
  }
  return null
}

export const convertISOToTime = (isoString: string): string => {
  return moment.utc(isoString).format('h:mm A')
}

export const convertISOToDate = (isoString: string): string => {
  return moment.utc(isoString).format('MM/DD/YYYY')
}

export const dateFormatter = (
  originalDate: string,
  inputSplitter?: string,
  outputSplitter = '-'
): string => {
  let year: number, month: number, day: number

  const detectedSplitter =
    inputSplitter ?? (originalDate.includes('/') ? '/' : '-')
  const parts = originalDate.split(detectedSplitter).map(Number)
  let formattedDate = ''
  if (detectedSplitter === '/') {
    ;[month, day, year] = parts
    formattedDate = `${year}${outputSplitter}${String(month).padStart(
      2,
      '0'
    )}${outputSplitter}${String(day).padStart(2, '0')}`
  } else {
    ;[year, month, day] = parts
    formattedDate = `${String(month).padStart(2, '0')}${outputSplitter}${String(
      day
    ).padStart(2, '0')}${outputSplitter}${String(year)}`
  }

  return formattedDate
}

export const removeCountryCode = (phoneNumber: string): string => {
  return phoneNumber?.replace(/^\+\d+\s*/, '')?.trim()
}

export const convertTimeToISO = (timeString: string): string => {
  const [hours, minutes] = timeString.split(':').map(Number)
  return moment
    .utc()
    .set({ hours, minutes, seconds: 0, milliseconds: 0 })
    .year(2024)
    .month(11)
    .date(30)
    .format('YYYY-MM-DDTHH:mm:ss+00:00')
}

export const convertTo24HourFormat = (timeString: string): string => {
  return moment(timeString, ['h:mm A']).format('HH:mm')
}

export const fetchLayoutIdByEntityId = async (
  dispatch: Dispatch<UnknownAction>,
  entityId: number,
  mode: string
) => {
  if (!entityId || !mode || Number.isNaN(entityId)) return null
  try {
    const response = await fetchLayoutIdApi({ mode, entityId })
    if (response) {
      return response?.data
    }
  } catch (err) {
    console.error(err)
    dispatch(
      addToaster({
        message: `Error fetching Layout ID`,
        type: 'error',
        id: uuid(),
      })
    )
  }
  return null
}
export const convertToCSV = (rows: string[][]): string => {
  return rows
    .map((row) => row.map((cell) => `"${cell.replace(/"/g, '""')}"`).join(','))
    .join('\n')
}
export const exportRawCSV = (
  rawText: string,
  fileName = 'report.csv',
  noOfColumns = 12,
  initialHeader = correspondenceLogsPage.COMMUNICATION_ID
) => {
  const normalized = rawText.replace(/\r\n/g, '\n').replace(/\n{2,}/g, '\n')
  const values: string[] = [...normalized.matchAll(/"([^"]*)"/g)].map(
    (m) => m[1]
  )

  const clientInfo: string[][] = [
    ['CLIENT-NAME'],
    [values[1] || ''],
    [''],
    [''],
  ]

  let i = 2
  const filters: string[][] = []
  while (i + 2 < values?.length && !values[i]?.includes(initialHeader)) {
    if (values[i] === correspondenceLogsPage.DATE_AND_TIME_KEY_UPPERCASE) {
      const dates = values[i + 2].split(',')
      const formattedDates = dates?.map((date) => {
        return moment(date)?.format('MM/DD/YYYY')
      })
      filters.push([values[i], values[i + 1], formattedDates?.join(',')])
    } else {
      filters.push([values[i], values[i + 1], values[i + 2]])
    }
    i += 3
  }

  const headers = values.slice(i, i + noOfColumns)
  i += noOfColumns

  const dataRows: string[][] = []
  while (i + 8 < values.length) {
    const row = values.slice(i, i + noOfColumns)
    const channelValue =
      row[headers.indexOf(correspondenceLogsPage.CHANNEL)]?.toLowerCase()
    const isLetter = channelValue === 'letter' || channelValue === 'email'
    const formattedRow = row.map((cell, idx) => {
      const header = headers[idx].trim()

      if (
        header === correspondenceLogsPage.DATE_AND_TIME ||
        header === correspondenceLogsPage.SENT_AT ||
        header === correspondenceLogsPage.RECEIVED_AT
      ) {
        return cell && cell !== '-'
          ? moment(cell).format('MM/DD/YYYY HH:mm')
          : cell
      }

      if (
        header === correspondenceLogsPage.RECEIVED_FROM ||
        (header === correspondenceLogsPage.SENDER_NAME && !isLetter)
      ) {
        return cell !== '-'
          ? formatPhoneNumberUi(cell, FORMAT_PATTERN.PHONE_INPUT)
          : cell
      }
      if (
        header === correspondenceLogsPage.RECIPIENT ||
        header === correspondenceLogsPage.RECIPIENT_TYPE
      ) {
        return cell !== '-'
          ? cell
              .split(',')
              .map((s) => s.trim())
              .filter((s) => s !== 'null')
              .map(
                (item: string) => item.charAt(0) + item.slice(1).toLowerCase()
              )
              .join(', ')
          : cell
      }

      return cell
    })

    dataRows.push(formattedRow)
    i += noOfColumns
  }

  const csvContent = convertToCSV([
    ...clientInfo,
    ...filters,
    [''],
    headers,
    ...dataRows,
  ])

  downloadCSV(csvContent, fileName)
}

export const exportApiRawToXLS = (
  rawText: string,
  fileName = 'report.xlsx',
  noOfColumns = 12,
  initialHeader = correspondenceLogsPage.COMMUNICATION_ID
) => {
  const normalized = rawText.replace(/\r\n/g, '\n').replace(/\n{2,}/g, '\n')
  const values: string[] = [...normalized.matchAll(/"([^"]*)"/g)].map(
    (m) => m[1]
  )

  const clientInfo: string[][] = [
    ['CLIENT-NAME'],
    [values[1] || ''],
    [''],
    [''],
  ]

  let i = 2
  const filters: string[][] = []
  while (i + 2 < values.length && !values[i].includes(initialHeader)) {
    if (values[i] === correspondenceLogsPage.DATE_AND_TIME_KEY_UPPERCASE) {
      const dates = values[i + 2].split(',')
      const formattedDates = dates?.map((date) => {
        return moment(date)?.format('MM/DD/YYYY')
      })
      filters.push([values[i], values[i + 1], formattedDates?.join(',')])
    } else {
      filters.push([values[i], values[i + 1], values[i + 2]])
    }
    i += 3
  }

  const headers = values.slice(i, i + noOfColumns)
  i += noOfColumns

  const dataRows: string[][] = []
  while (i + 8 < values.length) {
    const row = values.slice(i, i + noOfColumns)
    const channelValue =
      row[headers.indexOf(correspondenceLogsPage.CHANNEL)]?.toLowerCase()
    const isLetter = channelValue === 'letter' || channelValue === 'email'
    const formattedRow = row.map((cell, idx) => {
      const header = headers[idx].replace('"', '')
      if (
        header === correspondenceLogsPage.DATE_AND_TIME ||
        header === correspondenceLogsPage.SENT_AT ||
        header === correspondenceLogsPage.RECEIVED_AT
      ) {
        return cell !== '-'
          ? moment(cell)?.format('MM/DD/YYYY HH:mm')?.toString()
          : cell
      }

      if (
        header === correspondenceLogsPage.RECEIVED_FROM ||
        (header === correspondenceLogsPage.SENDER_NAME && !isLetter)
      ) {
        return cell !== '-'
          ? formatPhoneNumberUi(cell, FORMAT_PATTERN.PHONE_INPUT)
          : cell
      }
      if (
        header === correspondenceLogsPage.RECIPIENT ||
        header === correspondenceLogsPage.RECIPIENT_TYPE
      ) {
        return cell !== '-'
          ? cell
              .split(',')
              .map((s) => s.trim())
              .filter((s) => s !== 'null')
              .map(
                (item: string) => item.charAt(0) + item.slice(1).toLowerCase()
              )
              .join(', ')
          : cell
      }

      return cell
    })

    dataRows.push(formattedRow)
    i += noOfColumns
  }

  const sheetData: string[][] = [
    ...clientInfo,
    [''],
    ['SEARCH KEY', 'OPERATOR', 'SEARCH VALUE'],
    ...filters,
    [''],
    headers,
    ...dataRows,
  ]

  const ws = XLSX.utils.aoa_to_sheet(sheetData)

  const maxCols = Math.max(...sheetData.map((row) => row.length))
  ws['!cols'] = new Array(maxCols).fill({ wch: 30 })

  const range = XLSX.utils.decode_range(ws['!ref']!)
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddr = XLSX.utils.encode_cell({ r: R, c: C })
      const cell = ws[cellAddr]
      if (cell) {
        if (!cell.s) cell.s = {}
        cell.s.font = { name: 'Calibri', sz: 10 }
      }
    }
  }

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Correspondence_logs')

  XLSX.writeFile(wb, fileName, {
    bookType: 'xls',
    cellStyles: true,
  })
}
export const downloadCSV = (data: string, fileName: string) => {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const getDefaultActiveTabName = (uniqueKey: string) => {
  switch (uniqueKey) {
    case correspondenceLogsPage.OUTBOUND_LOWERCASE:
      return correspondenceLogsPage.OUTBOUND
    case correspondenceLogsPage.INBOUND_LOWERCASE:
      return correspondenceLogsPage.INBOUND
    default:
      return correspondenceLogsPage.OUTBOUND
  }
}

export const trimObjects = (
  obj: CorrespondenceOptions
): CorrespondenceOptions => {
  for (const key in obj) {
    const value = obj[key as keyof CorrespondenceOptions]

    if (value === null || value === undefined) {
      delete obj[key as keyof CorrespondenceOptions]
    } else if (Array.isArray(value) && value.length === 0) {
      delete obj[key as keyof CorrespondenceOptions]
    } else if (typeof value === 'object' && value !== null) {
      trimObjects(value as unknown as CorrespondenceOptions)

      if (Object.keys(value).length === 0) {
        delete obj[key as keyof CorrespondenceOptions]
      }
    }
  }
  return obj
}

export const removeEditableAndRedBackground = (html: string) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const editableDivs = doc.querySelectorAll('div')

  editableDivs.forEach((div) => {
    if (div.className.startsWith('editable')) {
      const span = div.querySelector(
        'span[contenteditable="true"]'
      ) as HTMLElement

      if (span) {
        span.setAttribute('contenteditable', 'false')
        span.style.backgroundColor = 'inherit'
      }
    }
  })

  return doc.body.innerHTML
}

export const toCamelCase = (snakeStr: string): string => {
  return snakeStr
    .toLowerCase()
    .split('_')
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join('')
}

export const fetchLayoutByEntityIdLayoutId = async (
  entityId: string,
  layoutId: string,
  dispatch: Dispatch<UnknownAction>
) => {
  try {
    const response = await getLayoutByIdApi({
      entityId: entityId ?? '',
      layoutId: layoutId ?? '',
    })
    if (response) {
      return response?.data
    }
  } catch (err) {
    console.error(err)
    dispatch(
      addToaster({
        message: `Error fetching Layout Data`,
        type: 'error',
        id: uuid(),
      })
    )
  }
  return null
}

export const formatFilterArray = (filterObject: TableFilterObjectBody) => {
  return {
    fields: filterObject?.fields ?? null,
    search_criteria: Object.values(filterObject?.search_criteria || {}),
  }
}

let REVERSE_CASE_TYPE_PERMISSION_MAPPING: { [key: string]: string[] } = {}

const getReverseCaseMapping = () => {
  REVERSE_CASE_TYPE_PERMISSION_MAPPING = getReverseMapping()
}
getReverseCaseMapping()

const programsWithPermissions = (
  programPermissions: ProgramPermissionsDataType,
  permission_name: string,
  operation_name: 'View Only' | 'Manage'
) => {
  if (isSuperAdmin()) return []
  const result: string[] = []
  for (const [programId, permissionsList] of Object.entries(
    programPermissions
  )) {
    if (permissionsList[permission_name]?.[operation_name] === true)
      result.push(programId)
  }
  return result
}

const userPermissionValue = (
  programPermissions: ProgramPermissionsDataType,
  permission_name: string,
  operation_name: 'View Only' | 'Manage'
) => {
  if (isSuperAdmin()) return true
  return Object.values(programPermissions).some(
    (program) => program[permission_name]?.[operation_name] === true
  )
}

const userPermissionValueForProgram = (
  programPermissions: ProgramPermissionsDataType,
  permission_name: string,
  operation_name: 'View Only' | 'Manage',
  program_id: string
) => {
  if (isSuperAdmin()) return true
  return (
    programPermissions[program_id]?.[permission_name]?.[operation_name] === true
  )
}

const userPermissionValueForQueueOnProgram = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string,
  case_type: string
) => {
  if (isSuperAdmin()) return true
  if (!case_type || !isCaseType(case_type)) return false
  const permissionName = caseTypePermissionMapping(case_type)
  return programPermissions[program_id]?.[permissionName]?.Manage === true
}

const userAssignmentPermissionForQueueOnProgram = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string,
  case_type: string
) => {
  if (isSuperAdmin()) return true
  return (
    userPermissionValueForQueueOnProgram(
      programPermissions,
      program_id,
      case_type
    ) &&
    programPermissions[program_id]?.[PERMISSION_MODULES.WORK_ASSIGNMENT]
      ?.Manage === true
  )
}

const userReassignmentPermissionForQueueOnProgram = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string,
  case_type: string
) => {
  if (isSuperAdmin()) return true
  return (
    userPermissionValueForQueueOnProgram(
      programPermissions,
      program_id,
      case_type
    ) &&
    programPermissions[program_id]?.[PERMISSION_MODULES.WORK_REASSIGNMENT]
      ?.Manage === true
  )
}

const userAssignmentPermissionForIntakeQueue = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string
) => {
  if (isSuperAdmin()) return true
  return (
    programPermissions[program_id]?.[PERMISSION_MODULES.INTAKE_TRIAGE]
      ?.Manage === true &&
    programPermissions[program_id]?.[PERMISSION_MODULES.WORK_ASSIGNMENT]
      ?.Manage === true
  )
}

const userDiscardIntakesPermissionForIntakeQueue = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string
) => {
  if (isSuperAdmin() || isProgramAdmin()) return true
  if (isReadOnlyUser()) return false
  return programPermissions[program_id]?.[PERMISSION_MODULES.DISCARD_INTAKES]
    ?.Manage
}

const userAssignmentPermissionForDocumentQueue = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string
) => {
  if (isSuperAdmin()) return true
  return (
    programPermissions[program_id]?.[PERMISSION_MODULES.MANAGE_ATTACHMENTS]
      ?.Manage === true &&
    programPermissions[program_id]?.[PERMISSION_MODULES.WORK_ASSIGNMENT]
      ?.Manage === true
  )
}

const userReassignmentPermissionForIntakeQueue = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string
) => {
  if (isSuperAdmin()) return true
  return (
    programPermissions[program_id]?.[PERMISSION_MODULES.INTAKE_TRIAGE]
      ?.Manage === true &&
    programPermissions[program_id]?.[PERMISSION_MODULES.WORK_REASSIGNMENT]
      ?.Manage === true
  )
}

const userReassignmentPermissionForDocumentQueue = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string
) => {
  if (isSuperAdmin()) return true
  return (
    programPermissions[program_id]?.[PERMISSION_MODULES.MANAGE_ATTACHMENTS]
      ?.Manage === true &&
    programPermissions[program_id]?.[PERMISSION_MODULES.WORK_REASSIGNMENT]
      ?.Manage === true
  )
}

const getPermissionValue = (
  programPermissions: ProgramPermissionsDataType,
  dataItem: DataTypeStore,
  isPrintQueue: boolean
) => {
  if (isPrintQueue)
    return userReassignmentPermissionForPrintMailQueue(
      programPermissions,
      dataItem['programs.id']?.toString() ??
        dataItem['hcp_program.id']?.toString()
    )
  if (!isPrintQueue)
    return userReassignmentPermissionForIntakeQueue(
      programPermissions,
      dataItem['programs.id']?.toString() ??
        dataItem['hcp_program.id']?.toString()
    )
}

const userBulkAssignmentPermission = (
  programPermissions: ProgramPermissionsDataType,
  dataItem: DataTypeStore,
  entityName = '',
  isPrintQueue = false
) => {
  if (isSuperAdmin()) return true
  return (
    (((dataItem['users.id'] === currentUserId() || !dataItem['users.id']) &&
      (entityName === DYNAMIC_QUEUE_CONSTANTS.CASE_LOWERCASE
        ? userReassignmentPermissionForQueueOnProgram(
            programPermissions,
            dataItem['programs.id']?.toString(),
            dataItem?.['services.service_name']?.toString()
          )
        : entityName === ENTITY_NAME.AE_PC_DOCUMENT
        ? userReassignmentPermissionForDocumentQueue(
            programPermissions,
            dataItem['programs.id']?.toString()
          )
        : getPermissionValue(programPermissions, dataItem, isPrintQueue))) ||
      userPermissionValueForProgram(
        programPermissions,
        PERMISSION_MODULES.BULK_WORK_ASSIGNMENTS,
        'Manage',
        dataItem['programs.id']?.toString() ??
          dataItem['hcp_program.id']?.toString()
      )) === true
  )
}

const userServicesForPrograms = (
  programPermissions: ProgramPermissionsDataType
): string[] => {
  if (isSuperAdmin()) return []
  const result = new Set<string>()
  getReverseCaseMapping()
  for (const [, permissionsList] of Object.entries(programPermissions)) {
    for (const [permissionName, permissionValue] of Object.entries(
      permissionsList
    )) {
      if (
        REVERSE_CASE_TYPE_PERMISSION_MAPPING[permissionName] &&
        permissionValue?.Manage
      ) {
        REVERSE_CASE_TYPE_PERMISSION_MAPPING[permissionName].forEach(
          (service) => result.add(service)
        )
      }
    }
  }
  return Array.from(result)
}

const userReassignmentPermissionForPrintMailQueue = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string
) => {
  if (isSuperAdmin()) return true
  return (
    programPermissions[program_id]?.[PERMISSION_MODULES.PRINT_MAIL]?.Manage ===
      true &&
    programPermissions[program_id]?.[PERMISSION_MODULES.WORK_REASSIGNMENT]
      ?.Manage === true
  )
}

const userAssignmentPermissionForPrintMailQueue = (
  programPermissions: ProgramPermissionsDataType,
  program_id: string
) => {
  if (isSuperAdmin()) return true
  return (
    programPermissions[program_id]?.[PERMISSION_MODULES.PRINT_MAIL]?.Manage ===
      true &&
    programPermissions[program_id]?.[PERMISSION_MODULES.WORK_ASSIGNMENT]
      ?.Manage === true
  )
}

const isTaskOwner = (
  task: WorkflowInstanceTaskType | null,
  userId: number | string
) => {
  if (task?.assignee?.id === userId) {
    return true
  } else {
    return false
  }
}

const userEditPermissionInWorkflow = (
  programPermissions: ProgramPermissionsDataType,
  caseData: CaseDataType | null,
  task: WorkflowInstanceTaskType | null,
  userId: number | string
) => {
  const hasServicePermission = userPermissionValueForQueueOnProgram(
    programPermissions,
    caseData?.programs?.id?.toString() ?? '',
    caseData?.services?.service_name ?? ''
  )
  return isSuperAdmin() || hasServicePermission || isTaskOwner(task, userId)
}

const userEditGlobalEntitySchema = (
  globalPermissions: PermissionsDataType,
  permission_name: string
) => {
  return (
    isSuperAdmin() ||
    isProgramAdmin() ||
    globalPermissions?.[permission_name]?.Manage
  )
}

export const permissionObject = {
  Permission_Set_Assignment_View: userPermissionValue,
  Permission_Set_Assignment_Manage: userPermissionValueForProgram,
  Correspondence_Logs_Manage: userPermissionValue,
  Correspondence_Logs_Manage_Program: userPermissionValueForProgram,
  Queue_Review_Manage: userPermissionValueForQueueOnProgram,
  Queue_Review_Manage_Intake: userPermissionValueForProgram,
  Queue_Case_Assignment: userAssignmentPermissionForQueueOnProgram,
  Queue_Case_Reassignment: userReassignmentPermissionForQueueOnProgram,
  Queue_Intake_Assignment: userAssignmentPermissionForIntakeQueue,
  Queue_Document_Assignment: userAssignmentPermissionForDocumentQueue,
  Queue_Intake_Reassignment: userReassignmentPermissionForIntakeQueue,
  Queue_Document_Reassignment: userReassignmentPermissionForDocumentQueue,
  Queue_Print_Mail_Assignment: userAssignmentPermissionForPrintMailQueue,
  Queue_Print_Mail_Reassignment: userReassignmentPermissionForPrintMailQueue,
  Queue_Bulk_Assignment: userBulkAssignmentPermission,
  Queue_Bulk_Assignment_Permission: userPermissionValueForProgram,
  Queue_Get_Work: userPermissionValue,
  Manage_Attachments_Manage: userPermissionValueForProgram,
  Queues_And_Cases_View: userPermissionValueForProgram,
  Manage_Workflow: userEditPermissionInWorkflow,
  Manage_Dashboard: userPermissionValueForProgram,
  Manage_Global_Schema: userEditGlobalEntitySchema,
  Queue_Discard_Intakes: userDiscardIntakesPermissionForIntakeQueue,
}

export const programPermissionsObject = {
  Permission_Set_Assignment_View: programsWithPermissions,
  Correspondence_Logs_View: programsWithPermissions,
  Queues_And_Cases_View: programsWithPermissions,
  Queue_Get_Work_Services: userServicesForPrograms,
}

export const hasSensitiveDataPermission = () => {
  if (isSuperAdmin()) return true
  const userPermissionValue =
    store.getState().clientPermissions.globalPermissions
  return !!userPermissionValue[PERMISSION_MODULES.MANAGE_CLIENT_CONTROLLED_DATA]
    ?.Manage
}

export type GlobalPermissionOperation = 'View Only' | 'Manage'

export const selectIsSuperAdminForPermissionAssignment = (
  state: RootState
): boolean =>
  (state.authUser.user?.superAdmin ?? false) &&
  state.authUser.user?.profile !== USER_PROFILES.SUPPORT

export const hasGlobalPermission = (
  permissionName: string,
  operation: GlobalPermissionOperation,
  state: RootState = store.getState()
): boolean =>
  state.clientPermissions.globalPermissions?.[permissionName]?.[operation] ===
  true

export const hasGlobalPermissionSetConfiguration = (
  operation: GlobalPermissionOperation = 'Manage',
  state: RootState = store.getState()
): boolean =>
  hasGlobalPermission(
    GLOBAL_UAM_PERMISSIONS.GLOBAL_PERMISSION_SET_CONFIGURATION,
    operation,
    state
  )

export const selectIsSupportUser = (state: RootState): boolean =>
  state.authUser.user?.profile === USER_PROFILES.SUPPORT

export const isSupportUserWithGlobalPaCapability = (
  state: RootState = store.getState()
): boolean =>
  selectIsSupportUser(state) &&
  (hasGlobalPermissionSetConfiguration('Manage', state) ||
    hasGlobalPermissionSetConfiguration('View Only', state))

export const canAccessGlobalPermissionSetConfiguration = (
  state: RootState = store.getState()
): boolean =>
  isSuperAdmin() ||
  isProgramAdmin() ||
  hasGlobalPermissionSetConfiguration('Manage', state) ||
  hasGlobalPermissionSetConfiguration('View Only', state)

export const canActAsAccessManagerOnPermissionAssignment = (
  state: RootState = store.getState()
): boolean =>
  selectIsSupportUser(state) &&
  hasGlobalPermissionSetConfiguration('Manage', state)

export const isUamPermissionSetDisabledForProfiles = (
  permissionSetName: string,
  targetProfiles: string[]
): boolean =>
  permissionSetName === GLOBAL_PERMISSION_SETS.USER_ACCESS_MANAGEMENT &&
  targetProfiles.some((profile) => profile !== USER_PROFILES.SUPPORT_USER)

export const openNewWindow = (path: string) => {
  const fromUrl = getTenantIdFromWindow()
  const fromRedux = store.getState().authUser.selectedClientTenant?.id
  const resolved =
    typeof fromUrl === 'number' && Number.isFinite(fromUrl)
      ? fromUrl
      : typeof fromRedux === 'number' && Number.isFinite(fromRedux)
      ? fromRedux
      : null
  const withTenant =
    resolved != null ? appendTenantIdToPath(path, resolved) : path
  openWithTenant(
    `${
      window.location.origin.endsWith('/')
        ? window.location.origin.slice(0, -1)
        : window.location.origin
    }${withTenant.startsWith('/') ? withTenant : `/${withTenant}`}`,
    '_blank'
  )
}

const replaceNotAvailable = (input: string): string => {
  return input?.replace('NOT_AVAILABLE', 'Not Entered')
}

export const formattedViewObject = (
  type: string,
  array: ViewObjectEntry[],
  tooltipArray?: string[],
  mode?: string
) => {
  return array
    ?.filter((item) => item.type === type)
    ?.map((item, index) => {
      const names = item?.name
        .map((n) => replaceNotAvailable(n.value))
        .join(' ')
      const value = item?.recipient
      // TODO: require later for entity name
      // const entityCapitalized =
      //   item.entity.charAt(0).toUpperCase() + item.entity.slice(1)
      const valueForLabel = item?.recipient
        ? formatPhoneNumberUi(item?.recipient, FORMAT_PATTERN.PHONE_INPUT)
        : ''
      const isPrimary = item?.formatter === 'true'
      const isOfficeFax = item?.recipient_label === RECIPENT_LABEL_OFFICE_FAX
      const finalLabel = isOfficeFax
        ? `${valueForLabel} ${isPrimary ? ' (Primary)' : ''}`
        : `${
            mode === COMM_TEMPLATE.EMAIL
              ? names === NAMESPACES.NOT_AVAILABLE_UPPERACSE || !value
                ? NAMESPACES.NOT_ENTERED
                : value
              : names === NAMESPACES.NOT_AVAILABLE_UPPERACSE || !names
              ? NAMESPACES.NOT_ENTERED
              : names
          } : ${
            value === NAMESPACES.NOT_AVAILABLE_UPPERACSE || !value
              ? NAMESPACES.NOT_ENTERED
              : valueForLabel
          } ${isPrimary ? ' (Primary)' : ''}`

      return {
        label: finalLabel,
        value: `${index} ${
          names === NAMESPACES.NOT_AVAILABLE_UPPERACSE || !names
            ? NAMESPACES.NOT_ENTERED
            : names
        } : ${
          value === NAMESPACES.NOT_AVAILABLE_UPPERACSE || !value
            ? NAMESPACES.NOT_ENTERED
            : value
        }`,
        tooltip: tooltipArray?.[index],
        viewObject: item as unknown as DataType,
      }
    })
}

export const formattedViewObjectForLetter = (
  type: string,
  array: ViewObjectEntry[],
  tooltipArray?: string[]
) => {
  return array
    ?.filter((item) => item.type === type)
    ?.map((item, index) => {
      const names = item?.name
        ?.map((n) => replaceNotAvailable(n?.value))
        ?.join(' ')

      return {
        label: `${
          names === NAMESPACES.NOT_AVAILABLE || !names
            ? NAMESPACES.NOT_ENTERED
            : names
        }`,
        value: `${index} ${
          names === NAMESPACES.NOT_AVAILABLE || !names
            ? NAMESPACES.NOT_ENTERED
            : names
        }`,
        tooltip: tooltipArray?.[index],
        viewObject: item as unknown as DataType,
      }
    })
}

export const formattedCorrespondenceRecipient = (
  type: string,
  array: ViewObjectEntry[],
  correspondanceType?: string
) =>
  array
    ?.filter((item) => item.type === type)
    ?.map((item) => {
      const names =
        item.name
          ?.map(({ value }) =>
            value === NAMESPACES.NOT_AVAILABLE_UPPERACSE
              ? NAMESPACES.NOT_ENTERED
              : value
          )
          .join(' ') || NAMESPACES.NOT_ENTERED

      const recipient =
        !item.recipient || item.recipient === NAMESPACES.NOT_AVAILABLE_UPPERACSE
          ? NAMESPACES.NOT_ENTERED
          : correspondanceType === COMM_TEMPLATE.LETTER_CAPITAL
          ? item.recipient
          : formatPhoneNumberUi(item.recipient, FORMAT_PATTERN.PHONE_INPUT)

      return `${names} : ${recipient}`
    })

export const fetchEntityDataByName = async (
  entityName: string,
  dispatch?: Dispatch<UnknownAction>
) => {
  try {
    const response = await fetchEntityIdByNameCorrespondingToSelectedClient(
      entityName
    )
    if (response) {
      return response?.data
    }
  } catch (err) {
    console.error(err)
    dispatch &&
      dispatch(
        addToaster({
          message: `${COMM_TEMPLATE?.ERROR_FETCHING}${entityName}${COMM_TEMPLATE?.ENTITY}`,
          type: 'error',
          id: uuid(),
        })
      )
  }
  return null
}

const removeCPrefix = (input: string) => {
  const parts = input?.split('.')
  const processed = parts?.map((part, index) => {
    if (index > 0 && part?.startsWith('c_')) {
      return part?.slice(2) // remove 'c_'
    }
    return part
  })
  return processed?.join('.')
}

export const getTooltipArray = async (
  type: string,
  viewObjectArray: ViewObjectEntry[],
  mode?: string
) => {
  const keys: string[][] = []

  viewObjectArray
    ?.filter((item) => item.type === type)
    ?.forEach((item) => {
      const innerKeys: string[] = []

      item.name?.forEach((nameEntry) => {
        innerKeys?.push(removeCPrefix(nameEntry?.key))
      })

      innerKeys?.push(removeCPrefix(item?.recipient_label ?? ''))
      keys?.push(innerKeys)
    })

  if (mode === COMM_TEMPLATE.EMAIL) {
    return viewObjectArray
      ?.filter((item) => item.type === type)
      ?.map((item) => item.recipient ?? '')
      ?.filter(Boolean)
  }

  const tooltipArray: string[] = keys.map((fields) => {
    const lastElement = fields[fields.length - 1]
    const prefix = fields.slice(0, -1).join(' | ')
    return `${prefix}${prefix ? ' :' : ''} ${lastElement}`
      .trim()
      .replace(/^:initial/i, '')
      .replace(/:+$/, '')
  })

  return tooltipArray
}

export const formatToWord = (name: string) => {
  if (!name) {
    return ''
  }
  return name
    .split('_')
    ?.map(
      (word: string) =>
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
    )
    .join(' ')
}

export const formatDashboardQueueName = (name: string) => {
  if (!name) {
    return ''
  }

  const queueName: string[] = []
  name.split(' ').forEach((word: string) => {
    if (word.toLowerCase() !== 'dashboard') {
      queueName.push(
        word?.charAt(0).toUpperCase() + word?.slice(1).toLowerCase()
      )
    }
  })

  return queueName.join(' ')
}

export const UTCtoBrowserTimeFormatter = (date_time: string): string => {
  try {
    let isoString = date_time

    const isZ = isoString.includes('Z')
    if (isZ) {
      isoString = isoString.replace('Z', '')
    }

    isoString = isoString.replace(/\.(\d{3})\d+/, '.$1')
    isoString += 'Z'

    const date = parseISO(isoString)
    if (isNaN(date.getTime())) return ''

    const datePart = date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })

    const timePart = date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })

    const offsetMin = -date.getTimezoneOffset()
    const sign = offsetMin >= 0 ? '+' : '-'
    const absOffset = Math.abs(offsetMin)
    const offsetHours = String(Math.floor(absOffset / 60)).padStart(2, '0')
    const offsetMinutes = String(absOffset % 60).padStart(2, '0')
    const formattedDate = `${datePart} ${timePart} (UTC${sign}${offsetHours}:${offsetMinutes})`
    return formattedDate
  } catch {
    return ''
  }
}

export const mergeFilters = (
  baseFilters: { criteria: formatDataObject[] }[] | undefined,
  overrideFilters: EntityLookupSearchCriteria[] | undefined
): EntityLookupSearchCriteria[] => {
  const mergedMap = new Map<string, LookupRelatedEntities>()

  // Step 1: Process base filters
  baseFilters?.forEach((filter) => {
    filter.criteria.forEach((crit) => {
      const key = `${crit.field_name}|${crit.operation ?? 'EQUALS'}`
      mergedMap.set(key, {
        field_name: crit.field_name,
        operation: crit.operation ?? 'EQUALS',
        values: crit.values ?? [],
        ...(crit.direction ? { direction: crit.direction } : {}),
      })
    })
  })

  // Step 2: Merge override filters
  overrideFilters?.forEach((filter) => {
    filter.criteria.forEach((crit) => {
      const key = `${crit.field_name}|${crit.operation ?? 'EQUALS'}`
      const existing = mergedMap.get(key)
      const overrideValues = crit.values ?? []

      if (existing) {
        const combinedValues = Array.from(
          new Set([...(existing.values ?? []), ...overrideValues])
        )
        mergedMap.set(key, {
          ...existing,
          values: combinedValues,
        })
      } else {
        mergedMap.set(key, {
          field_name: crit.field_name,
          operation: crit.operation ?? 'EQUALS',
          values: overrideValues,
          ...(crit.direction ? { direction: crit.direction } : {}),
        })
      }
    })
  })

  // Step 3: Group by field_name into EntityLookupSearchCriteria[]
  const grouped = new Map<string, LookupRelatedEntities[]>()

  mergedMap.forEach((crit) => {
    const fieldGroup = grouped.get(crit.field_name) ?? []
    fieldGroup.push(crit)
    grouped.set(crit.field_name, fieldGroup)
  })

  const result: EntityLookupSearchCriteria[] = Array.from(
    grouped.entries()
  ).map(([_, criteria]) => ({
    criteria,
    ...(overrideFilters?.length ? { logical_operator: 'AND' } : {}),
  }))

  return result
}

export const mergeRelatedEntities = (
  base?: Record<
    string,
    | { select?: string[] }
    | {
        select?: string[]
        filters: {
          criteria: formatDataObject[]
        }[]
      }
  >,
  override?: TableFilterLookupObjectBody
): TableFilterLookupObjectBody => {
  const merged: TableFilterLookupObjectBody = {}

  const allKeys = new Set([
    ...Object.keys(base || {}),
    ...Object.keys(override || {}),
  ])

  allKeys.forEach((entityKey) => {
    const baseEntry = base?.[entityKey] as {
      select?: string[]
      filters?: { criteria: formatDataObject[] }[]
    }
    const overrideEntry = override?.[entityKey]

    const baseFilters = baseEntry?.filters ?? []
    const overrideFilters = overrideEntry?.filters ?? []

    if (!baseFilters.length && overrideFilters.length) {
      merged[entityKey] = overrideEntry!
    } else if (baseFilters.length && !overrideFilters.length) {
      merged[entityKey] = {
        filters: baseFilters.map((f) => ({
          logical_operator: 'AND',
          criteria: (f.criteria || []).map((crit) => ({
            field_name: crit.field_name,
            operation: crit.operation ?? 'EQUALS',
            values: crit.values ?? [],
            ...(crit.direction ? { direction: crit.direction } : {}),
          })),
        })),
        select: baseEntry?.select,
      }
    } else {
      const mergedCriteriaMap = new Map<string, LookupRelatedEntities>()

      const combinedCriteria = [
        ...baseFilters.flatMap((f) => f.criteria),
        ...overrideFilters.flatMap((f) => f.criteria),
      ]

      combinedCriteria.forEach((crit) => {
        const key = `${crit.field_name}|${crit.operation ?? 'EQUALS'}`
        const existing = mergedCriteriaMap.get(key)

        if (existing) {
          const combinedValues = Array.from(
            new Set([...(existing.values ?? []), ...(crit.values ?? [])])
          )
          mergedCriteriaMap.set(key, {
            ...existing,
            values: combinedValues,
          })
        } else {
          mergedCriteriaMap.set(key, {
            field_name: crit.field_name,
            operation: crit.operation ?? 'EQUALS',
            values: crit.values ?? [],
            ...(crit.direction ? { direction: crit.direction } : {}),
          })
        }
      })

      merged[entityKey] = {
        filters: [
          {
            logical_operator: 'AND',
            criteria: Array.from(mergedCriteriaMap.values()),
          },
        ],
        select: overrideEntry?.select ?? baseEntry?.select,
      }
    }
  })

  return merged
}

export const logErrorMessage = (source: string, error: unknown) => {
  console.error(`Error fetching ${source} data: `, error)
}

export function containsHtmlElements(str: string) {
  const result = str
  const parser = new DOMParser()
  const doc = parser.parseFromString(result, 'text/html')
  return doc.body.children.length > 0
}

export const downloadPdfFromBase64 = async (
  base64String: string,
  fileName = 'document.pdf'
) => {
  let fetchUrl: string

  if (
    base64String.startsWith('http://') ||
    base64String.startsWith('https://')
  ) {
    fetchUrl = base64String
  } else {
    fetchUrl = base64String.startsWith('data:application/pdf;base64,')
      ? base64String
      : `data:application/pdf;base64,${base64String}`
  }

  const response = await fetch(fetchUrl)
  const blob = await response.blob()

  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = fileName
  document.body.appendChild(link) // Required for Firefox
  link.click()
  link.remove()
}

export const getDownloadURL = async (
  dispatch: Dispatch<UnknownAction>,
  caseId: string,
  url?: string,
  name?: string,
  documentType?: string
) => {
  let fileURL = url
  let fileName = 'attachment.pdf'

  if (name) {
    const nameParts = name.split('.')
    if (nameParts.length >= 2) {
      const ext = nameParts.pop()
      const base = nameParts.join('.')
      fileName = `${base}-${caseId}.${ext}`
    } else {
      fileName = `${name}-${caseId}.pdf` // fallback if no extension
    }
  }

  const fileExt = name?.split('.').pop()?.toLowerCase()

  // If PDF, download from base64
  if (
    fileExt === 'pdf' &&
    documentType === COMM_TEMPLATE?.DYNAMIC_DOCUMENT_UPPERCASE
  ) {
    downloadPdfFromBase64(fileURL ?? '', fileName)
    return
  }

  dispatch(showLoader())

  try {
    // If the input URL contains HTML, convert it via API
    if (containsHtmlElements(url ?? '')) {
      const payload = {
        body: url,
        program_id: 0,
        case_id: '',
        editable_fields: [
          {
            type: 0,
            documentId: undefined,
            editableValues: {},
          },
        ],
      }

      const result = await getDownloadDocURLApi(payload)
      fileURL = result?.data?.url
    }

    if (!fileURL) {
      throw new Error('File URL is not available.')
    }

    // Fetch the file and trigger download
    const response = await fetch(fileURL)
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.statusText}`)
    }

    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)

    const downloadLink = document.createElement('a')
    downloadLink.href = blobUrl
    downloadLink.download = fileName
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)

    URL.revokeObjectURL(blobUrl)
    dispatch(
      addToaster({
        message: `${COMM_TEMPLATE.DOWNLOADED_SUCCESSFULLY}`,
        type: 'success',
        id: uuid(),
      })
    )
  } catch (error) {
    console.error('Error downloading the file:', error)
  } finally {
    dispatch(hideLoader())
  }
}

export const getPreviewURL = async (
  dispatch: Dispatch<UnknownAction>,
  url?: string
): Promise<string> => {
  let previewUrl = url || ''
  try {
    dispatch(showLoader())
    if (containsHtmlElements(previewUrl ?? '')) {
      const payload = {
        body: previewUrl,
        program_id: 0,
        case_id: '',
        editable_fields: [
          {
            type: 0,
            documentId: undefined,
            editableValues: {},
          },
        ],
      }

      const result = await getDownloadDocURLApi(payload)
      previewUrl = result?.data?.url ?? ''
    }
  } catch (error) {
    console.error('Error generating preview URL:', error)
  } finally {
    dispatch(hideLoader())
  }
  return previewUrl
}

export const checkQueType = (
  queueData: DynamicQueuesType | undefined
): string | undefined => {
  const filters =
    queueData?.related_entities?.category_communication_type?.filters
  if (!filters) return undefined
  const criteriaList = filters.flatMap((filter) => filter.criteria)
  const matchedCriterion = criteriaList.find(
    (criterion) =>
      Array.isArray(criterion.values) && criterion.values[0] !== undefined
  )
  return matchedCriterion?.values?.[0]
}

export const isFileSizeValid = (file: File, maxSizeMB = 5): boolean => {
  const maxSizeInBytes = maxSizeMB * 1024 * 1024
  return file?.size <= maxSizeInBytes
}

export const allowedExtensions = [
  EXTENSIONS.PDF,
  EXTENSIONS.DOCX,
  EXTENSIONS.XLSX,
  EXTENSIONS.XLS,
  EXTENSIONS.DOC,
  EXTENSIONS.DOCM,
  EXTENSIONS.XLSM,
  EXTENSIONS.TXT,
  EXTENSIONS.CSV,
  EXTENSIONS.JPG,
  EXTENSIONS.PNG,
  EXTENSIONS.JPEG,
]

export const isValidFileType = (file: File) => {
  const fileExtension = file.name.split('.').pop()?.toLowerCase()
  return fileExtension && allowedExtensions.includes(fileExtension)
}
export const formatNumberTwoDigits = (num: number) =>
  num < 10 ? num.toString().padStart(2, '0') : num.toString()

export const fetchLayoutsByEntityName = async (
  dispatch: Dispatch<UnknownAction>,
  entityName: string
) => {
  dispatch(showLoader())

  const filterPayload = [
    {
      logical_oprator: 'AND',
      criteria: [
        {
          values: [`${entityName}`],
          operation: 'EQUALS',
          field_name: 'entity_name',
        },
      ],
    },
  ]
  const payload = {
    entity_name: 'layout',
    select: ['type', 'entity_id', 'entity_name', 'status'],
    page: 0,
    size: 2000,
    filters: filterPayload,
  }
  const response = await getGenericEntityListingAPI(
    payload as unknown as GetGenericEntityListingApiType
  )
  dispatch(hideLoader())
  return response
}

export const fetchDocumentPdfByTemplateIdCaseId = async (
  caseId: number,
  templateId: number
) => {
  const response = await getBase64forDocumentPreview(caseId, templateId)
  return response?.data
}

export const entityMap: Record<string, string> = {
  patients: 'Patient',
  providers: 'Provider',
  contacts: 'Contact',
}

export const reverseMappingOfRequestorName = (
  content: {
    name: string
    record_status: string
    record_key: string
    record_id: number
    entity_type: string
    id: number
  }[]
) => {
  return content.map((item) => ({
    ...item,
    entity_type: entityMap[item.entity_type] || '',
  }))
}

export const checkIfRecordFieldsEnabled = (
  isLeftPanel: boolean | undefined,
  updatedDataObj?: React.MutableRefObject<{
    channel: string | undefined
    product: string | undefined
    program: string | undefined
    requestor: string | undefined
  }>,
  initialDataObj?: React.MutableRefObject<{
    channel: string | undefined
    product: string | undefined
    program: string | undefined
    requestor: string | undefined
  }>
) => {
  if (isLeftPanel) return true
  const initial = initialDataObj?.current ?? {}
  const keys = Object.keys(
    initialDataObj?.current ?? {}
  ) as (keyof typeof initial)[]
  const areObjectsEqual = keys.every((key) => {
    const initialVal =
      initialDataObj?.current[key as keyof typeof initialDataObj.current]
    const updatedVal =
      updatedDataObj?.current[key as keyof typeof updatedDataObj.current]
    return (
      (initialVal?.toString() ?? '') === (updatedVal?.toString() ?? '') &&
      initialVal
    )
  })

  return areObjectsEqual
}

export const getEntityName = (entityType: string) => {
  switch (entityType) {
    case NAMESPACES.PATIENT_KEY:
    case NAMESPACES.PROVIDER_KEY:
    case NAMESPACES.CONTACT_KEY:
    case NAMESPACES.PAYER_KEY:
    case NAMESPACES.ORGANIZATION_KEY:
      return `${entityType?.toLowerCase()}s`
    case NAMESPACES.PHARMACY_KEY:
    case NAMESPACES.FACILITY_KEY:
      return `${entityType?.toLowerCase().slice(0, -1)}ies`
    default:
      return entityType?.toLowerCase()
  }
}

export const setPhoneTypeIdFunction = (
  obj: ContactPatientProviderType,
  newValue: number,
  isTextingAllowed?: boolean
) => {
  const phoneKeyName =
    obj?.select?.find((item: string) =>
      item?.toLowerCase()?.includes('phone')
    ) ?? obj?.select?.[0]
  const index = _.findIndex(
    _.get(obj, `related_entities.${phoneKeyName}.filters[0].criteria`),
    { field_name: 'phone_type_id' }
  )
  const newObj = _.cloneDeep(obj)
  if (newObj.related_entities?.[obj?.select?.[0]].filters[0].criteria) {
    newObj.related_entities[obj.select[0]].filters[0].criteria[index].values = [
      newValue,
    ]
    if (isTextingAllowed) {
      newObj.related_entities[obj?.select?.[0]].select.push('texting_allowed')
      newObj.related_entities[obj?.select?.[0]].filters[0].criteria.push({
        values: ['true'],
        operation: 'EQUALS',
        field_name: 'texting_allowed',
      })
    }
  }
  return newObj
}

export const getTomorrowDate = () => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return tomorrow.toISOString().split('T')[0] // returns 'YYYY-MM-DD'
}

export const convertToUTCISOString = (edtDateTimeStr: string) => {
  const [datePart, timePart] = edtDateTimeStr.split(' ')

  const [month, day, year] = datePart.split('/')

  const formatted = `${year}-${month}-${day}T${timePart}:00+00:00`
  return formatted
}

export const getTimestamp = (date: string | null | undefined): number => {
  return date ? moment(date)?.valueOf() : -Infinity
}

export const sortByLatest = (a: RecordType, b: RecordType): number => {
  const latestA = Math.max(
    getTimestamp(a?.modified_at),
    getTimestamp(a?.created_at)
  )
  const latestB = Math.max(
    getTimestamp(b?.modified_at),
    getTimestamp(b?.created_at)
  )
  return latestB - latestA
}
export const getLatestActiveRecord = (
  records: RecordType[],
  phoneType: string,
  isAddress = false
): RecordType | null => {
  const activeRecords = records?.filter(
    (r) =>
      r?.record_status === 'ACTIVE' &&
      (isAddress || r?.phone_type?.['value'] === phoneType)
  )
  if (activeRecords?.length === 0) return null

  const preferredRecords = activeRecords?.filter((r) => r?.is_preferred)
  if (preferredRecords?.length > 0) {
    return preferredRecords?.sort(sortByLatest)?.[0]
  }

  const nonPreferredRecords = activeRecords?.filter((r) => !r?.is_preferred)
  if (nonPreferredRecords?.length > 0) {
    return nonPreferredRecords?.sort(sortByLatest)?.[0]
  }

  return null
}

export const buildAgentLabel = (agentId?: AuthUser | null) => {
  if (!agentId) return NAMESPACES.UNKNOWN

  const name = [agentId.first_name, agentId.last_name].filter(Boolean).join(' ')
  const id = agentId.user_id ?? ''

  if (name && id) return `${name} | ${id}`
  if (name) return name
  if (id) return id
  return NAMESPACES.UNKNOWN
}

export const getAddressFromObject = (address: AddressType | null): string => {
  const parts = [
    address?.address_line_1,
    address?.address_line_2,
    address?.city,
    address?.state?.name,
    address?.zip_code,
  ]

  return parts?.filter((part) => part && part?.trim() !== '')?.join(', ')
}

export const toTitleCase = (str: string) => {
  return str
    ?.toLowerCase()
    ?.split(' ')
    ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
    ?.join(' ')
}

export const fetchPatientCorrespondingToCaseId = async (caseId: string) => {
  const payload: GetGenericEntityListingApiType = {
    entity_id: ENTITY_ID.CASE,
    select: [ENTITY_NAME.PATIENT],
    filters: [],
    related_entities: {
      patient: {
        select: ['id', 'patient_key'],
        criteria: [],
      },
    },
  }
  const patientResponse = await getGenericEntityListingAPI(payload, caseId)
  return patientResponse
}

export const detachCaseFromCommunication = async (
  dispatch: Dispatch<UnknownAction>,
  intakeType: string | undefined,
  caseId: string | null,
  caseEntityId: string | undefined,
  communicationId: string | undefined,
  communicationEntityId: string | undefined
) => {
  try {
    dispatch(showLoader())
    if (intakeType === NAMESPACES.FAX_UPPERCASE) {
      const response = await fetchTypeStatusForCommunications(
        NAMESPACES.COMMUNICATION_STATUS_LOWERCASE
      )
      const faxEnrollmentStatusId = response?.data?.find(
        (item: { value: string }) =>
          item?.value?.toLowerCase() === NAMESPACES.RECEIVED_LOWERCASE
      )?.id
      if (faxEnrollmentStatusId) {
        await updateIntake(caseId ?? '', {
          meta_data: {
            entity_id: caseEntityId,
            embedded: ['id,record_status'],
          },
          data: {
            record_status: STRINGS.INACTIVE,
            id: caseId ?? '',
            _state: NAMESPACES.CHANGED,
          },
        })

        const payload: UpdateIntakePayload = {
          meta_data: {
            entity_id: communicationEntityId,
            embedded: [
              'id,products_id,requestor_id,category_status_id,case_id',
            ],
          },
          data: {
            products_id: '',
            requestor_id: '',
            case_id: '',
            id: communicationId,
            category_status_id: faxEnrollmentStatusId,
            _state: NAMESPACES.CHANGED,
          },
        }

        await updateIntake(communicationId, payload)
        await detachIntake(communicationId, caseId ?? '')
      }
    } else if (intakeType === NAMESPACES.INTERACTION_UPPERCASE) {
      const payload: UpdateIntakePayload = {
        meta_data: {
          entity_id: communicationEntityId,
          embedded: ['id,case_id'],
        },
        data: {
          case_id: '',
          id: communicationId,
          _state: NAMESPACES.CHANGED,
        },
      }
      await updateIntake(communicationId, payload)
      await detachIntake(communicationId, caseId ?? '')
    } else {
      const response = await fetchTypeStatusForCommunications(
        NAMESPACES.WEB_ENROLLMENT_STATUS
      )
      const webEnrollmentStatusId = response?.data?.find(
        (item: { value: string }) =>
          item?.value?.toLowerCase() === NAMESPACES.RECEIVED_LOWERCASE
      )?.id
      if (webEnrollmentStatusId) {
        await updateIntake(caseId ?? '', {
          meta_data: {
            entity_id: caseEntityId,
            embedded: ['id,record_status'],
          },
          data: {
            record_status: STRINGS.INACTIVE,
            id: caseId ?? '',
            _state: NAMESPACES.CHANGED,
          },
        })
        await updateIntake(communicationId, {
          meta_data: {
            entity_id: communicationEntityId,
            embedded: [
              'id,product_id,requestor_id,enrollment_status_id,case_id',
            ],
          },
          data: {
            product_id: '',
            requestor_id: '',
            id: communicationId,
            enrollment_status_id: webEnrollmentStatusId,
            _state: NAMESPACES.CHANGED,
            case_id: '',
          },
        })
      }
    }
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(hideLoader())
  }
}
export const formatInsurancePhones = (item: {
  insuranceId: number
  payerName: string
  phones: string
  recordKey: string
  type: string
}) => {
  const phonesArray: FieldValues[] =
    typeof item.phones === 'string'
      ? JSON.parse(item.phones)
      : item.phones || []

  return phonesArray
    ?.filter((phone) => phone.phone_type === 'Fax')
    .map((phone, index) => {
      const formattedNumber = formatPhoneNumberUi(
        phone.phone_number,
        FORMAT_PATTERN.PHONE_INPUT
      )
      const view_object = [
        {
          entity: 'c_payers',
          entity_name: 'payer',
          name: [
            {
              key: 'case.c_payer.name',
              value: item.payerName,
            },
          ],
          recipient_label:
            'case.c_case_insurances.c_plans.c_plan_phones.phone_numbers',
          recipient: phone?.phone_number,
          type: 'to',
          record_ids: [phone?.id],
          record_keys: [item?.recordKey],
        },
      ]

      const isPrimary = phone.preferred === true

      return {
        label: `${item.payerName} : ${formattedNumber}${
          isPrimary ? ' (Primary)' : ''
        }`,
        value: `${index} ${item.payerName} : ${phone.phone_number}`,
        phones: phonesArray,
        viewObject: view_object,
      }
    })
}
export const getStackedBarOptions = ({
  height,
  categories,
  series,
  legendEnabled = false,
  xAxisLabelsEnabled = true,
  yAxisLabelsEnabled = false,
  pointWidth = 15,
  onBarClick,
  activePoint,
  highlightedStatus,
}: BarChartOptionsProps): Highcharts.Options => {
  const modifiedSeries: Highcharts.SeriesBarOptions[] = (
    series as Highcharts.SeriesBarOptions[]
  ).map((s) => {
    if (!('data' in s)) return s
    return {
      ...s,
      data: (s.data as (number | Highcharts.PointOptionsObject)[])?.map(
        (val, index) => {
          const category = categories[index]

          const isActive =
            !activePoint ||
            (activePoint.category === category && activePoint.status === s.name)

          const rawY = typeof val === 'number' ? val : val?.y

          let safeY = rawY
          if (safeY === 0) safeY = null
          else if (safeY === 1) safeY = 1.1

          const base =
            typeof val === 'number'
              ? { y: safeY, originalY: rawY }
              : { ...val, y: safeY, originalY: rawY }

          return {
            ...base,
            opacity: isActive ? undefined : 0.5,
            dataLabels: {
              style: {
                opacity: isActive ? 1 : 0.5,
                fontWeight: isActive ? 'bold' : 'normal',
                fontSize: '0.625rem',
              },
            },
          }
        }
      ),
    }
  })
  return {
    chart: {
      type: 'bar',
      height,
    },

    title: { text: '' },

    xAxis: {
      categories,
      title: { text: null },
      labels: { enabled: xAxisLabelsEnabled },
    },

    yAxis: {
      type: 'logarithmic',
      min: 1,
      title: { text: null },
      labels: { enabled: yAxisLabelsEnabled },
      gridLineDashStyle: 'Dash' as Highcharts.DashStyleValue,
    },
    tooltip: {
      formatter: function () {
        const ctx = this as unknown as TooltipContext

        const originalValue = ctx.point?.options?.originalY ?? 0

        return `
      <b>${this.category}</b><br/>
      ${this.series.name}: ${originalValue ?? 0}
    `
      },
    },

    legend: {
      enabled: legendEnabled,
      reversed: false,
    },

    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            const ctx = this as unknown as TooltipContext
            return ctx.point.options?.originalY ?? null
          },
        },
      },
      series: {
        states: {
          inactive: { enabled: false },
          hover: { enabled: true },
        },
        pointWidth,
        groupPadding: 0.1,
        pointPadding: 0.05,
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          color: '#000',
          style: {
            fontSize: '10px',
            textOutline: 'none',
          },
        },
        cursor: 'pointer',
        point: {
          events: {
            click: function (this: Highcharts.Point) {
              const ctx = this as unknown as TooltipContext
              const status = String(ctx.series.name)

              const isHighlightedStatus =
                !highlightedStatus || status === highlightedStatus
              if (!isHighlightedStatus) return

              onBarClick?.({
                userId: ctx.userId ?? 0,
                category: String(ctx.category),
                status: String(ctx.series.name),
                count: Number(ctx.options?.originalY ?? 0),
              })
            },
          },
        },
      } as PlotSeriesOptions,
    },

    series: modifiedSeries,

    credits: { enabled: false },
  }
}

export const getColumnChartOptions = ({
  height,
  categories,
  series,
  xAxisTitle = '',
  yAxisTitle = '',
  onBarClick,
}: ColumnChartOptionsProps): Highcharts.Options => ({
  chart: {
    type: 'column',
    height,
  },

  title: { text: '' },

  xAxis: {
    categories,
    title: { text: xAxisTitle },
    lineWidth: 0,
    tickWidth: 0,
    labels: {
      style: {
        fontSize: '12px',
        fontWeight: '500',
      },
    },
  },

  yAxis: {
    title: { text: yAxisTitle },
    min: 0,
    gridLineColor: '#E5E5E5',
    gridLineDashStyle: 'Dash' as Highcharts.DashStyleValue,
    labels: {
      style: { fontSize: '12px' },
    },
  },

  legend: { enabled: false },

  plotOptions: {
    column: {
      pointPadding: 0.2,
      borderWidth: 0,
    },
    series: {
      cursor: 'pointer',
      point: {
        events: {
          click: function () {
            onBarClick?.({
              category: this.category as string,
              count: this.y as number,
            })
          },
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          textOutline: 'none',
        },
      },
    },
  },

  series,

  credits: { enabled: false },
})
export const formatUSPhoneNumber = (phone: string) => {
  if (phone.includes('+1')) return phone
  const digits = phone?.replace(/\D/g, '')
  return `+1 ${digits}`
}

export const getNestedValue = (obj: unknown, path: string): unknown =>
  path.split('.').reduce<unknown>((res, key) => {
    return res && typeof res === 'object'
      ? (res as Record<string, unknown>)[key]
      : ''
  }, obj)

export const getDedupeResultLabel = (
  matchResult: keyof typeof MATCH_DEDUPE_RESULTS
) => {
  return MATCH_DEDUPE_RESULT_LABEL[matchResult]
}

export const getDedupeResult = (
  fieldKeyName: string,
  matchResult?: keyof typeof MATCH_DEDUPE_RESULTS,
  records?: number
) => {
  if (
    fieldKeyName === 'patient' &&
    matchResult === MATCH_DEDUPE_RESULTS.NO_MATCH
  ) {
    return MATCH_DEDUPE_RESULTS.RECORD_CREATED
  }

  if (matchResult !== MATCH_DEDUPE_RESULTS.STRONG) {
    return matchResult
  }

  return records === 1 ? MATCH_DEDUPE_RESULTS.STRONG : MATCH_DEDUPE_RESULTS.WEAK
}

export const normalizeBooleanOperator = (filter?: TableFilterObjectBody) => {
  if (!filter?.search_criteria) return filter

  return {
    ...filter,
    search_criteria: Object.fromEntries(
      Object.entries(filter?.search_criteria)?.map(
        ([key, value]: [string, SearchCriteria]) => [
          key,
          {
            ...value,
            operator:
              value.operator === 'EQUALS_BOOLEAN' ? 'EQUALS' : value.operator,
          },
        ]
      )
    ),
  }
}

export const isReady = (value: unknown): boolean => {
  if (value === undefined || value === null) return false

  if (typeof value === 'string') return value.trim().length > 0

  if (typeof value === 'number') return true // allow 0

  if (typeof value === 'boolean') return true

  if (typeof value === 'function') return true

  if (value instanceof Date) return !isNaN(value.getTime())

  if (Array.isArray(value)) return value.length > 0

  if (value instanceof Map || value instanceof Set) return value.size > 0

  if (typeof value === 'object') return Object.keys(value).length > 0

  return true
}

export const getFileType = (contentType?: string, url?: string): FileType => {
  if (!contentType && !url) return EXTENSIONS.UNSUPPORTED as FileType

  const type = contentType?.toLowerCase() ?? ''
  const urlLower = url?.toLowerCase() ?? ''
  const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
  if (
    type === MULTI_UPLOAD_FILE_TYPE.PDF ||
    type === EXTENSIONS.PDF ||
    urlLower.endsWith(`.${EXTENSIONS.PDF}`)
  ) {
    return EXTENSIONS.PDF as FileType
  }

  if (
    type.startsWith('image/') ||
    /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(urlLower) ||
    imageTypes.includes(type)
  ) {
    return EXTENSIONS.IMAGE as FileType
  }

  if (
    type === MULTI_UPLOAD_FILE_TYPE.DOCX ||
    urlLower.endsWith(`.${EXTENSIONS.DOCX}`)
  ) {
    return EXTENSIONS.DOCX as FileType
  }

  if (
    type === MULTI_UPLOAD_FILE_TYPE.DOC ||
    urlLower.endsWith(`.${EXTENSIONS.DOC}`)
  ) {
    return EXTENSIONS.DOC as FileType
  }

  if (
    type === MULTI_UPLOAD_FILE_TYPE.TXT ||
    urlLower.endsWith(`.${EXTENSIONS.TXT}`)
  ) {
    return EXTENSIONS.TXT as FileType
  }

  return EXTENSIONS.UNSUPPORTED as FileType
}

export const getContentType = (attachmentsData?: ContentTypeProps) => {
  let contentType = attachmentsData?.content_type
  if (!contentType) {
    contentType =
      attachmentsData?.name?.endsWith('.pdf') ||
      attachmentsData?.alias?.endsWith('.pdf')
        ? 'application/pdf'
        : ''
  }
  return contentType
}

export const resendCommunication = async (
  communicationId: number,
  setRefetchKey?: React.Dispatch<React.SetStateAction<number>>
) => {
  try {
    store.dispatch(showLoader())
    const response = await resendCommunicationAPI(communicationId)
    if (response) {
      store.dispatch(
        addToaster({
          message: STRINGS.COMMUNICATION_RESENT,
          id: uuid(),
          type: 'success',
        })
      )

      const event = new CustomEvent('customRefetch')
      window.dispatchEvent(event)
    }
    setRefetchKey && setRefetchKey((prev) => prev + 1)
  } catch (error) {
    console.error('Error resending communication:', error)
  } finally {
    store.dispatch(hideLoader())
  }
}

export const startPollingForIntake = ({ caseId }: { caseId: string }) => {
  const POLL_DELAYS = [5000, 7000, 11000, 15000, 21000]
  let attempts = 0
  const maxAttempts = 5

  const returnResult = new Promise((resolve, reject) => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null

    const poll = async () => {
      attempts++
      try {
        const result = await getWorkflowByEntityNameAndRecordId({
          recordId: caseId ?? '',
          entityName: 'case',
        })
        if (
          (result?.data?.workflow_instance?.state !==
            WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND &&
            result?.data?.workflow_instance?.state !==
              WORKFLOW_STATUS.WAITING) ||
          attempts >= maxAttempts
        ) {
          timeoutId = null
          resolve(result?.data ?? null)
          return
        }
        const delay =
          POLL_DELAYS[attempts] ?? POLL_DELAYS[POLL_DELAYS.length - 1]
        timeoutId = setTimeout(poll, delay)
      } catch (err) {
        if (timeoutId) {
          clearTimeout(timeoutId)
          timeoutId = null
        }
        reject(err)
      }
    }

    timeoutId = setTimeout(poll, POLL_DELAYS[0])
  })
  return returnResult as FieldValues
}

const _inflightCaseDataFetches = new Map<string, FieldValues>()

export const fetchCaseData = async (
  caseId: string,
  dispatch: Dispatch<UnknownAction>
) => {
  if (!caseId) return

  if (_inflightCaseDataFetches.has(caseId)) {
    return _inflightCaseDataFetches.get(caseId)
  }

  const request = getEntityDataByIdEntityNameEmbedded(
    'case',
    ['programs', 'services', 'users', 'products'],
    caseId
  )
    .then((caseDataResponse) => {
      dispatch(updateCaseData(caseDataResponse.data))
      return caseDataResponse
    })
    .catch((err) => {
      console.error(err)
    })
    .finally(() => {
      _inflightCaseDataFetches.delete(caseId)
    })

  _inflightCaseDataFetches.set(caseId, request)
  return request
}
export const parseBoolean = (value: boolean | string): boolean => {
  if (typeof value === 'boolean') return value
  if (typeof value === 'string') return value.toLowerCase() === 'true'
  return false
}

export const getTotalFromObject = (obj?: Record<string, number>): number => {
  if (!obj) return 0
  if (typeof obj === 'number') return obj
  return Object.values(obj)?.reduce((sum, val) => sum + (val ?? 0), 0) ?? 0
}
export const buildSubCounts = (
  obj?: string | number | Record<string, number>
): { label: string; value: string }[] | number => {
  if (!obj) return []
  if (typeof obj === 'number') return obj

  return Object.entries(obj)?.map(([key, value]) => ({
    label: key,
    value: String(value ?? 0),
  }))
}

export const buildUiDataMappings = (
  columns: TableColumnType<DataTypeStore>[]
): UiDataMappingsType => ({
  ...Object.fromEntries(
    columns.map(({ accessor, header }) => [accessor, { alias: [header] }])
  ),
})

export const extractUsersFromAgeBucket = (
  apiData: AgeBucketDashboardResponse
): Set<string> => {
  const data = apiData?.age_bucket_dashboard?.data ?? {}

  return new Set(
    Object.keys(data).filter((name) => name !== DASHBOARD.UNASSIGNED_LOWERCASE)
  )
}

export const buildUserWiseSeries = (
  usersData: UserStatusSummaryList,
  key: 'overdue' | 'at_risk' | 'on_track' | 'paused',
  color: string
): Highcharts.SeriesOptionsType => ({
  type: 'bar',
  name:
    key === 'at_risk'
      ? DASHBOARD.AT_RISK
      : key === 'on_track'
      ? DASHBOARD.ON_TRACK
      : key === 'overdue'
      ? DASHBOARD.OVERDUE
      : key === 'paused'
      ? DASHBOARD.PAUSED_MI
      : '',
  data: usersData.map((u) => ({
    y: u[key] ?? 0,
    userId: u.user_id,
    userName: u.name,
  })),
  color,
})

export const getIntakeEntityName = (name: string) => {
  if (name === INTAKE_QUEUE.FAX || name === INTAKE_QUEUE.MAIL) {
    return QUEUE_STRINGS.COMMUNICATION_LOWERCASE
  }
  return QUEUE_STRINGS.HCP_PORTAL_ENTITY_LOWERCASE
}

export const getUrgencyIndexObject = (status: string, tileStatus: string) => {
  return {
    select: ['id', 'status'],
    filters: [
      {
        criteria: [
          {
            field_name: 'status',
            operation: 'LIKE',
            values: [
              status === DASHBOARD.PAUSED_MI ? status.slice(0, -4) : status,
            ],
          },
          {
            field_name: 'status',
            operation: 'LIKE',
            values: [
              tileStatus === DASHBOARD.PAUSED_MI
                ? tileStatus.slice(0, -4)
                : tileStatus,
            ],
          },
          {
            field_name: 'id',
            operation: 'IS_NOT_NULL',
            values: [],
          },
        ],
      },
    ],
  }
}

export const handleStatusHighlight = (
  status: string,
  chart?: Highcharts.Chart
) => {
  if (!chart) return
  chart.series.forEach((series) => {
    if (series.name === status) {
      series.setState('hover')
      series.update(
        {
          opacity: 1,
          enableMouseTracking: true,
          dataLabels: {
            enabled: true,
          },
        } as SeriesOptionsType,
        false
      )
    } else {
      series.setState('inactive')
      series.update(
        {
          opacity: 0.5,
          enableMouseTracking: false,
          dataLabels: {
            enabled: false,
          },
        } as SeriesOptionsType,
        false
      )
    }
  })
  chart.redraw()
}

export const handleStatusFade = (status: string, chart?: Highcharts.Chart) => {
  if (!chart) return

  chart.series.forEach((series) => {
    if (series.name === status) {
      series.setState('inactive')
      series.update(
        {
          opacity: 0.5,
          enableMouseTracking: false,
          dataLabels: {
            enabled: false,
          },
        } as SeriesOptionsType,
        false
      )
    } else {
      series.setState('')
      series.update(
        {
          opacity: 1,
          enableMouseTracking: true,
          dataLabels: {
            enabled: true,
          },
        } as SeriesOptionsType,
        false
      )
    }
  })

  chart.redraw()
}

export const getFilterBasedOnUser = (label: string, userId: string | null) => {
  return [
    {
      direction: 'ASC',
      field_name: handleUserFieldName(label),
      operation: userId ? 'LIKE' : 'IS_NULL',
      values: [userId ?? ''],
    },
  ]
}

export const handleUserFieldName = (name: string) => {
  if (name === DASHBOARD.INTAKE) {
    return 'users_id'
  } else {
    return 'user_id'
  }
}

export const getFormattedStatus = (status: string) => {
  if (status === DASHBOARD.PAUSED_MI) {
    return status.replace(/\(MI\)$/, '')
  }

  return INTAKE_STATUS.includes(status) ? status : ''
}

export const checkTileData = (
  data: Record<string, Record<string, number>>
): boolean => {
  const values = Object.values(data)
  return !values.every((value) => value === null)
}

export const handleProgramFieldName = (name: string) => {
  if (name === INTAKE_QUEUE.FAX || name === INTAKE_QUEUE.MAIL) {
    return 'programs_id'
  } else if (name === INTAKE_QUEUE.WEB) {
    return 'hcp_program_id'
  } else {
    return 'program_id'
  }
}

export const parseErrorMessage = (input: string) => {
  const match = input.match(/^(\w+):\s*([\s\S]*)$/)

  if (!match) {
    return {
      type: null,
      message: input,
    }
  }

  return {
    type: match[1],
    message: match[2].trim(),
  }
}

export const transformByService = (
  data: Record<string, Record<string, number>>
) => {
  const result: Record<string, Record<string, number>> = {}

  Object.entries(data).forEach(([status, services]) => {
    Object.entries(services).forEach(([service, value]) => {
      if (!result[service]) result[service] = {}
      result[service][status] = value
    })
  })

  return result
}

export const invalidateToken = async () => {
  try {
    await invalidateMsalUserToken()
  } catch (err) {
    console.log(err)
  }
}
